import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('League')
export class League {

  @JsonProperty('league_id', Number)
  leagueId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('tier', Number)
  tier: number = 0;

  @JsonProperty('league_previous_id', Number)
  leaguePreviousId: number = 0;

  @JsonProperty('league_next_id', Number)
  leagueNextId: number = 0;

  @JsonProperty('free_credits_bonus_percent', Number)
  freeCreditsBonus: number = 0;
}
